import { useTranslationsProvider } from '@mfw/components';

import type { FetchPublicGoalsArgs } from '../api/types/user.types';

import { useInfiniteQuery } from './base';
import { queryKeys } from '../queryKeys';

export default function usePublicGoals(
  args: Omit<FetchPublicGoalsArgs, 'locale'>,
  enabled = true,
) {
  const { locale } = useTranslationsProvider();
  const { queryFn, queryKey } = queryKeys.goals.fetchInfiniteGoals({
    filters: args.filters,
    locale,
  });
  return useInfiniteQuery({
    enabled,
    initialPageParam: '1',
    meta: {
      limit: args.filters?.limit ?? '25',
    },
    queryFn: async (context: any) => {
      return queryFn({ ...context, locale, queryKey });
    },
    queryKey,
  });
}
